document.addEventListener('DOMContentLoaded', () => {
  const mainImage = document.querySelector('[data-main-image]');
  document.querySelectorAll('[data-thumb]').forEach((thumb) => {
    thumb.addEventListener('click', () => {
      if (!mainImage) return;
      mainImage.src = thumb.dataset.image;
      mainImage.srcset = '';
      document.querySelectorAll('[data-thumb]').forEach((item) => item.classList.remove('is-active'));
      thumb.classList.add('is-active');
    });
  });

  const form = document.querySelector('#product-form');
  const stickyButton = document.querySelector('[data-sticky-submit]');
  if (form && stickyButton) stickyButton.addEventListener('click', () => form.requestSubmit());

  const price = document.querySelector('[data-current-price]');
  const compare = document.querySelector('[data-compare-price]');
  const stickyPrice = document.querySelector('[data-sticky-price]');
  document.querySelectorAll('[data-variant-choice]').forEach((choice) => {
    choice.addEventListener('change', () => {
      if (!choice.checked) return;
      if (price) price.textContent = choice.dataset.price;
      if (stickyPrice) stickyPrice.textContent = choice.dataset.price;
      if (compare) {
        compare.textContent = choice.dataset.compare || '';
        compare.hidden = !choice.dataset.compare;
      }
    });
  });

  document.querySelectorAll('[data-scroll-buy]').forEach((button) => {
    button.addEventListener('click', () => document.querySelector('[data-product-info]')?.scrollIntoView({ behavior: 'smooth' }));
  });
});
